import { HeartBank } from "../../../managers/HeartBank.ts";
import template from "./hb-trove.mjs";
import { render } from "lit-html";
import { downloadFile, pickFile, B, isIOS, TOKENS } from "../../global.ts";
import { Media } from "../../../managers/Media.ts";
import { Diamond, Diamonds } from "../../../models/Trove.ts";
import { Me } from "../../../managers/Me.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";
import { HbMain } from "../hb-main.ts";

const AUDIO = new URL("../../../public/audio.svg", import.meta.url).href;
const PLAY = new URL("../../../public/play.svg", import.meta.url).href;

export class HbTrove extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private trove = new Diamonds();
    private media = new Media();
    private me = new Me();
    private modal: ModalInterface;
    private main = document.querySelector("hb-main") as HbMain; // for checkin spinner

    private container: HTMLElement;
    private creator: HTMLSpanElement;
    private ad: HTMLParagraphElement;
    private cover: HTMLVideoElement;
    private footer: HTMLElement;
    private info: HTMLParagraphElement;
    private thank: HTMLButtonElement;
    private tokens: HTMLElement;
    private share: HTMLButtonElement;
    private copy: HTMLButtonElement;
    private close: HTMLButtonElement;

    private diamonds: HTMLUListElement;
    private diamondAd: HTMLInputElement;
    private diamondAdd: HTMLButtonElement;

    private actions: HTMLElement;
    private actionAd: HTMLButtonElement;
    private actionUrl: HTMLButtonElement;
    private actionDownload: HTMLButtonElement;
    private actionTrash: HTMLButtonElement;

    private dialog: HTMLDialogElement;
    private dialogProgress: HTMLElement;
    private dialogPhoto: HTMLButtonElement;
    private dialogCamera: HTMLButtonElement;
    private dialogVideo: HTMLButtonElement;
    private dialogCamcorder: HTMLButtonElement;
    private dialogAudio: HTMLButtonElement;
    private dialogMicrophone: HTMLButtonElement;
    private dialogStop: HTMLButtonElement;
    private dialogCancel: HTMLButtonElement;
    private dialogClose: HTMLButtonElement;
    private dialogAiPicture: HTMLButtonElement;
    private dialogAiShort: HTMLButtonElement;
    private dialogAiSong: HTMLButtonElement;

    // audio
    private mediaRecorder: MediaRecorder | null = null;
    private chunks: BlobPart[] = [];

    constructor() {
        super();
        render(template(null), this);

        this.container = this.querySelector("#hb-trove")!;
        this.creator = this.querySelector("#hb-trove-diamond-creator")!;
        this.ad = this.querySelector("#hb-trove-ad")!;
        this.cover = this.querySelector("#hb-trove-cover")!;
        this.footer = this.querySelector("#hb-trove-footer")!;
        this.info = this.querySelector("#hb-trove-info")!;
        this.thank = this.querySelector("#hb-trove-thank")!;
        this.tokens = this.querySelector("#hb-trove-tokens")!;
        this.close = this.querySelector("#hb-trove-close")!;
        this.share = this.footer.firstElementChild as HTMLButtonElement;
        this.copy = this.footer.lastElementChild as HTMLButtonElement;

        this.diamonds = this.querySelector("#hb-trove-diamonds")!;
        this.diamondAd = this.querySelector("#hb-trove-diamond-title")!;
        this.diamondAdd = this.querySelector("#hb-trove-diamond-add")!;

        this.actions = this.querySelector("#hb-trove-actions")!;
        this.actionAd = this.querySelector("#hb-trove-action-ad")!;
        this.actionUrl = this.querySelector("#hb-trove-action-url")!;
        this.actionDownload = this.querySelector("#hb-trove-action-download")!;
        this.actionTrash = this.querySelector("#hb-trove-action-trash")!;

        this.dialog = this.querySelector("#hb-trove-dialog")!;
        this.dialogProgress = this.querySelector("#hb-trove-dialog-progress")!;
        this.dialogPhoto = this.querySelector("#hb-trove-dialog-photo")!;
        this.dialogCamera = this.querySelector("#hb-trove-dialog-camera")!;
        this.dialogVideo = this.querySelector("#hb-trove-dialog-video")!;
        this.dialogCamcorder = this.querySelector(
            "#hb-trove-dialog-camcorder"
        )!;
        this.dialogAudio = this.querySelector("#hb-trove-dialog-audio")!;
        this.dialogMicrophone = this.querySelector(
            "#hb-trove-dialog-microphone"
        )!;
        this.dialogStop = this.querySelector("#hb-trove-dialog-stop")!;
        this.dialogCancel = this.querySelector("#hb-trove-dialog-cancel")!;
        this.dialogClose = this.querySelector("#hb-trove-dialog-close")!;
        this.dialogAiPicture = this.querySelector(
            "#hb-trove-dialog-ai-picture"
        )!;
        this.dialogAiShort = this.querySelector("#hb-trove-dialog-ai-short")!;
        this.dialogAiSong = this.querySelector("#hb-trove-dialog-ai-song")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                //window.location.hash = "#";
            },
            onShow: () => {
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-trove",
            override: true
        };

        this.modal = new Modal(this.container, modalOptions, instanceOptions);
    }

    connectedCallback() {
        this.addActionListeners();
        this.addDialogListeners();

        this.diamondAd.addEventListener("keydown", (event: KeyboardEvent) => {
            if (event.key === "Enter") {
                event.preventDefault();
                this.dialog.showModal();
                // if (this.diamondAd.value.trim()) this.dialog.showModal();
                // else alert("Please enter an announcement for your B-Diamond");
            }
        });

        this.diamondAdd.addEventListener("click", () => {
            this.dialog.showModal();
            // if (this.diamondAd.value.trim()) this.dialog.showModal();
            // else alert("Please enter an announcement for your B-Diamond");
        });

        this.share.addEventListener("click", async () => {
            const shareData = {
                title: "HeartBank® Diamond",
                text: "", //TODO: later save user's message ?
                url: `${B}/d/${this.getSelectedDiamond()}`,
                files: []
            };

            if (navigator.canShare && navigator.canShare(shareData)) {
                try {
                    await navigator.share(shareData);
                    console.log("Shared successfully");
                } catch (error: any) {
                    if (
                        error.name === "AbortError" ||
                        error.name === "InvalidStateError"
                    ) {
                        console.warn("Sharing was cancelled:", error);
                    } else {
                        console.error(error);
                    }
                }
            } else {
                alert("Sorry, Web Share is not supported on this device.");
            }
        });

        this.copy.addEventListener("click", async () => {
            await navigator.clipboard.writeText(
                `${B}/d/${this.getSelectedDiamond()}`
            );
            alert("This B-Diamond has been copied to your clipboard!");
        });

        this.thank.addEventListener("click", async () => {
            this.footer.classList.add("hidden");
            this.thank.classList.add("hidden");
            this.tokens.classList.remove("hidden");
            this.container.scrollTo({
                top: this.container.scrollHeight,
                behavior: "smooth"
            });
        });

        this.close.addEventListener("click", () => {
            this.cover.pause();
        });

        // not used bc conflicts with video controls
        // this.cover.addEventListener("click", async () => {
        //     const diamond = (await this.trove.get(this.getSelectedDiamond()))!;
        //     if (diamond.url) window.open(diamond.url, "_blank");
        // });

        this.heartbank.addAuthStateListener((user) => {
            //render(template(user), this);
            if (user) this.renderDiamonds(user.uid); // && !this.diamonds.hasChildNodes()
        });
    }

    private addActionListeners() {
        this.actionAd.addEventListener("click", async () => {
            this.actionAd.disabled = true;
            const diamond = (await this.trove.get(this.getSelectedDiamond()))!;
            const ad = prompt(
                `Please enter ${diamond.ad ? "a new" : "an"} announcement for this B-Diamond:`,
                diamond.ad
            );
            if (ad !== diamond.ad) {
                const span = this.querySelector(
                    `#d-${diamond.id} > div > span`
                ) as HTMLSpanElement;
                span.textContent =
                    (await this.trove.editAd(diamond.id!, ad || "")) ||
                    "No Announcement";
                span.classList.toggle("opacity-50", !ad);
                //await this.renderDiamonds();
            }
            this.actionAd.disabled = false;
        });

        this.actionUrl.addEventListener("click", async () => {
            this.actionUrl.disabled = true;
            const diamond = (await this.trove.get(this.getSelectedDiamond()))!;
            await this.editURL(diamond);
            this.actionUrl.disabled = false;
        });

        this.actionDownload.addEventListener("click", async () => {
            this.actionUrl.disabled = true;
            const diamond = (await this.trove.get(this.getSelectedDiamond()))!;
            await downloadFile(diamond.ad, diamond.src); // extension auto added
            this.actionUrl.disabled = false;
        });

        this.actionTrash.addEventListener("click", async () => {
            if (confirm("Are you sure you want to delete this B-Diamond?")) {
                this.actionTrash.disabled = true;
                const diamond = (await this.trove.get(
                    this.getSelectedDiamond()
                ))!;
                await this.media.removeFile(diamond.src);
                if (diamond.thumbnail) this.media.removeFile(diamond.thumbnail);
                await this.trove.remove(diamond.id!);
                const li = this.querySelector(
                    `#d-${diamond.id}`
                ) as HTMLLIElement;
                li.remove();
                //await this.renderDiamonds();
                this.actionTrash.disabled = false;
                history.replaceState(null, "", `#/trove`);
                this.renderActions();
                //window.location.hash = "#/trove";
            }
        });
    }

    private async editURL(diamond: Diamond, retry?: string) {
        const a = this.querySelector(
            `#d-${diamond.id} > div > a`
        ) as HTMLAnchorElement;
        const button = this.querySelector(
            `#d-${diamond.id} > button`
        ) as HTMLButtonElement;

        let url = prompt(
            retry ||
                `Please enter a${diamond.url ? " new" : ""} redirect URL for this B-Diamond:`,
            diamond.url
        );

        if (url !== diamond.url) {
            if (url === null) {
                // ignore
            } else if (url === "") {
                button.dataset.url = await this.trove.editUrl(diamond.id!, url);
                a.removeAttribute("href");
                //await this.renderDiamonds();
            } else {
                try {
                    // url = url.trim();
                    // if (
                    //     !(
                    //         url.startsWith("http://") ||
                    //         url.startsWith("https://")
                    //     )
                    // )
                    //     url = "https://" + url;
                    const link = new URL(url);
                    a.href = await this.trove.editUrl(
                        diamond.id!,
                        link.toString()
                    );
                    button.dataset.url = a.href;
                    //await this.renderDiamonds();
                } catch {
                    this.editURL(diamond, "Please enter a valid URL:");
                }
            }
        }
    }

    private addDialogListeners() {
        this.dialogPhoto.addEventListener("click", async () => {
            this.dialogPhoto.disabled = true;
            this.dialogPhoto.style.opacity = "0.5";
            await this.processPhoto(false).catch(() => {});
            this.dialogPhoto.style.opacity = "";
            this.dialogPhoto.disabled = false;
        });
        this.dialogCamera.addEventListener(
            "click",
            this.processPhoto.bind(this, true, undefined)
        );

        this.dialogVideo.addEventListener("click", async () => {
            this.dialogVideo.disabled = true;
            this.dialogVideo.style.opacity = "0.5";
            await this.processVideo(false).catch(() => {});
            this.dialogVideo.style.opacity = "";
            this.dialogVideo.disabled = false;
        });
        this.dialogCamcorder.addEventListener(
            "click",
            this.processVideo.bind(this, true, undefined)
        );

        this.dialogAudio.addEventListener("click", async () => {
            this.dialogAudio.disabled = true;
            this.dialogAudio.style.opacity = "0.5";
            await this.processAudio(false).catch(() => {});
            this.dialogAudio.style.opacity = "";
            this.dialogAudio.disabled = false;

            // isIOS
            //     ? this.processVideo.bind(this, false, undefined)
            //     : this.processAudio.bind(this, false, undefined)
        });
        // this.dialogMicrophone.addEventListener(
        //     "click",
        //     this.processAudio.bind(this, true, undefined)
        //     // isIOS
        //     //     ? this.processVideo.bind(this, true, undefined)
        //     //     : this.processAudio.bind(this, true, undefined)
        // );
        this.dialogMicrophone.addEventListener("click", async () => {
            this.dialogMicrophone.classList.add("hidden");
            this.dialogStop.classList.remove("hidden");

            const stream = await navigator.mediaDevices.getUserMedia({
                audio: true
            });
            const mimeType = MediaRecorder.isTypeSupported("audio/mp4")
                ? "audio/mp4"
                : "audio/webm;codecs=opus";
            this.mediaRecorder = new MediaRecorder(stream, {
                mimeType
            });

            this.mediaRecorder.ondataavailable = (e: BlobEvent) => {
                if (e.data.size > 0) this.chunks.push(e.data);
            };

            this.mediaRecorder.onstop = async () => {
                if (confirm("Would you like to keep this voice recording?")) {
                    const blob = new Blob(this.chunks, {
                        type: mimeType
                    });
                    const file = new File([blob], "b-audio", {
                        type: mimeType
                    });
                    // const ext = mimeType.includes("mp4") ? "m4a" : "webm";
                    // const blob = new Blob(this.chunks, {
                    //     type: mimeType
                    // });
                    // const file = new File([blob], `b-audio.${ext}`, {
                    //     type: `audio/${ext}`
                    // });
                    await this.processAudio(true, file);
                }
                this.chunks = [];
                this.dialogMicrophone.classList.remove("hidden");
                this.dialogStop.classList.add("hidden");
            };

            this.mediaRecorder.start();
        });
        this.dialogStop.addEventListener("click", () =>
            this.mediaRecorder?.stop()
        );

        this.dialogAiPicture.addEventListener("click", () =>
            alert("Create a personalized photo with AI! (coming soon)")
        );
        this.dialogAiShort.addEventListener("click", () =>
            alert("Create a personalized video with AI! (coming soon)")
        );
        this.dialogAiSong.addEventListener("click", () =>
            alert("Create a personalized song with AI! (coming soon)")
        );

        this.dialogCancel.addEventListener("click", () => {}); //TODO: cancel upload
        this.dialogClose.addEventListener("click", () => this.dialog.close());
    }

    private toggleLoading(isShow: boolean) {
        const progress = this.querySelector(
            "#hb-trove-dialog-progress-container"
        ) as HTMLElement;
        const buttons = this.querySelector(
            "#hb-trove-dialog-buttons-container"
        ) as HTMLElement;

        if (isShow) {
            progress.classList.remove("hidden");
            buttons.classList.add("hidden");
            this.dialogClose.classList.add("hidden");
            this.dialogCancel.classList.remove("hidden");
        } else {
            progress.classList.add("hidden");
            buttons.classList.remove("hidden");
            this.dialogClose.classList.remove("hidden");
            this.dialogCancel.classList.add("hidden");
        }
    }

    private async processPhoto(isCapture: boolean, retry?: File) {
        if (this.heartbank.user && this.heartbank.user.phoneNumber) {
            let photo =
                retry ||
                (await pickFile({
                    accept: "image/*",
                    capture: isCapture ? "camera" : undefined
                }));
            if (photo) {
                this.toggleLoading(true);
                try {
                    const avatar = await this.media.createAvatarFromFile(photo);
                    const thumbnail = await this.media.storeFile(
                        avatar.name,
                        avatar,
                        (percent) => {
                            this.dialogProgress.style.width = percent + "%";
                            this.dialogProgress.textContent = `Uploading Thumbnail: ${percent}%`;
                        }
                    );
                    const src = await this.media.storeFile(
                        photo.name,
                        photo,
                        (percent) => {
                            this.dialogProgress.style.width = percent + "%";
                            this.dialogProgress.textContent = `Uploading Image: ${percent}%`;
                        }
                    );
                    const diamond = await this.trove.create(
                        this.heartbank.user.uid,
                        this.diamondAd.value.trim(),
                        thumbnail,
                        src,
                        "",
                        photo.size,
                        "image"
                    );
                    this.diamondAd.value = "";
                    //window.location.hash = `#/trove/${diamond.id}`;
                    history.replaceState(null, "", `#/trove/${diamond.id}`);
                    await this.renderDiamonds(this.heartbank.user.uid);
                    await this.renderActions();
                    this.dialog.close();
                } catch (error: any) {
                    alert(error.message);
                } finally {
                    this.toggleLoading(false);
                }
            }
        } else {
            if (this.heartbank.user) {
                if (
                    confirm(
                        "Only humans with a Heart of Mithril or above can create B-Diamonds.\n\nWould you like to prove your humanity by confirming your phone number now?"
                    )
                ) {
                    // localStorage.setItem(
                    //     "redirect-lockbox",
                    //     window.location.hash
                    // );
                    this.dialog.close();
                    window.location.hash = "#/humanity/mithril";
                }
            } else {
                if (
                    confirm(
                        "You need to be logged in to create B-Diamonds.\n\nWould you like to log in now?"
                    )
                ) {
                    localStorage.setItem(
                        "redirect-login",
                        window.location.hash
                    );
                    this.dialog.close();
                    window.location.hash = "#/login";
                }
            }
        }
    }

    private async processVideo(isCapture: boolean, retry?: File) {
        if (this.heartbank.user && this.heartbank.user.phoneNumber) {
            let video =
                retry ||
                (await pickFile({
                    accept: "video/*",
                    capture: isCapture ? "camcorder" : undefined
                }));
            if (video) {
                try {
                    const result = await this.media.validateVideoFile(video);
                    if (result.isValid && result.poster) {
                        this.toggleLoading(true);
                        const thumbnail = await this.media.storeFile(
                            result.poster.name,
                            result.poster,
                            (percent) => {
                                this.dialogProgress.style.width = percent + "%";
                                this.dialogProgress.textContent = `Uploading Poster: ${percent}%`;
                            }
                        );
                        const src = await this.media.storeFile(
                            video.name,
                            video,
                            (percent) => {
                                this.dialogProgress.style.width = percent + "%";
                                this.dialogProgress.textContent = `Uploading Video: ${percent}%`;
                            }
                        );
                        const diamond = await this.trove.create(
                            this.heartbank.user.uid,
                            this.diamondAd.value.trim(),
                            thumbnail,
                            src,
                            "",
                            video.size,
                            "video"
                        );
                        this.diamondAd.value = "";
                        //window.location.hash = `#/trove/${diamond.id}`;
                        history.replaceState(null, "", `#/trove/${diamond.id}`);
                        await this.renderDiamonds(this.heartbank.user.uid);
                        await this.renderActions();
                        this.toggleLoading(false);
                        this.dialog.close();
                    } else alert(result.errorMessage);
                } catch (error: any) {
                    alert(error.message);
                }
            }
        } else {
            if (this.heartbank.user) {
                if (
                    confirm(
                        "Only humans with a Heart of Mithril or above can create B-Diamonds.\n\nWould you like to prove your humanity by confirming your phone number now?"
                    )
                ) {
                    // localStorage.setItem(
                    //     "redirect-lockbox",
                    //     window.location.hash
                    // );
                    this.dialog.close();
                    window.location.hash = "#/humanity/mithril";
                }
            } else {
                if (
                    confirm(
                        "You need to be logged in to create B-Diamonds.\n\nWould you like to log in now?"
                    )
                ) {
                    localStorage.setItem(
                        "redirect-login",
                        window.location.hash
                    );
                    this.dialog.close();
                    window.location.hash = "#/login";
                }
            }
        }
    }

    private async processAudio(isCapture: boolean, retry?: File) {
        if (this.heartbank.user && this.heartbank.user.phoneNumber) {
            let audio =
                retry ||
                (await pickFile({
                    accept: isIOS ? "*/*" : "audio/*", // mp4 is selectable but error // WEIRD: iphone only allow select video files instead of audio files!
                    capture: isCapture ? "microphone" : undefined
                }));
            if (audio) {
                try {
                    if (isIOS || (await this.media.isAudioValid(audio))) {
                        this.toggleLoading(true);
                        const src = await this.media.storeFile(
                            audio.name,
                            audio,
                            (percent) => {
                                this.dialogProgress.style.width = percent + "%";
                                this.dialogProgress.textContent = `Uploading Audio: ${percent}%`;
                            }
                        );
                        const diamond = await this.trove.create(
                            this.heartbank.user.uid,
                            this.diamondAd.value.trim(),
                            "", // no thumbnail for audio
                            src,
                            "",
                            audio.size,
                            "audio"
                        );
                        this.diamondAd.value = "";
                        //window.location.hash = `#/trove/${diamond.id}`;
                        history.replaceState(null, "", `#/trove/${diamond.id}`);
                        await this.renderDiamonds(this.heartbank.user.uid);
                        await this.renderActions();
                        this.toggleLoading(false);
                        this.dialog.close();
                    } else
                        alert(
                            "Your audio file needs to be less than 30 minutes."
                        );
                } catch (error: any) {
                    alert(error.message);
                }
            }
        } else {
            if (this.heartbank.user) {
                if (
                    confirm(
                        "Only humans with a Heart of Mithril or above can create B-Diamonds.\n\nWould you like to prove your humanity by confirming your phone number now?"
                    )
                ) {
                    // localStorage.setItem(
                    //     "redirect-lockbox",
                    //     window.location.hash
                    // );
                    this.dialog.close();
                    window.location.hash = "#/humanity/mithril";
                }
            } else {
                if (
                    confirm(
                        "You need to be logged in to create B-Diamonds.\n\nWould you like to log in now?"
                    )
                ) {
                    localStorage.setItem(
                        "redirect-login",
                        window.location.hash
                    );
                    this.dialog.close();
                    window.location.hash = "#/login";
                }
            }
        }
    }

    private async renderDiamonds(uid: string = "") {
        this.main.showSpinner();
        this.diamonds.innerHTML = "";
        if (!uid) uid = this.heartbank.user?.uid || "";
        const trove = uid ? await this.trove.getAll(uid) : [];

        if (trove.length > 0) {
            for (const [index, diamond] of trove.entries()) {
                const li = document.createElement("li");
                li.id = "d-" + diamond.id!;
                li.classList.add(
                    "inline-flex",
                    "justify-between",
                    "items-center",
                    "w-full",
                    "px-4",
                    "py-2",
                    "text-sm",
                    "font-medium",
                    index === trove.length - 1 ? "border-b-0" : "border-b",
                    "border-gray-200",
                    "rounded-t-lg",
                    "hover:bg-gray-100",
                    "hover:text-blue-700",
                    "focus:z-10",
                    "focus:ring-2",
                    "focus:ring-blue-700",
                    "focus:text-blue-700",
                    "dark:border-gray-600",
                    "dark:hover:bg-gray-600",
                    "dark:hover:text-white",
                    "dark:focus:ring-gray-500",
                    "dark:focus:text-white"
                );

                const a = document.createElement("a");
                if (diamond.url) a.href = diamond.url;
                a.target = "_blank";
                a.classList.add("mr-4", "inline-block", "relative");

                const img = document.createElement("img");
                img.src = diamond.thumbnail || AUDIO;
                img.alt = "Thumbnail";
                img.classList.add("w-7", "h-7", "block");
                a.appendChild(img);

                if (diamond.type === "video") {
                    const play = document.createElement("img");
                    play.src = PLAY;
                    play.classList.add(
                        "absolute",
                        "top-1/2",
                        "left-1/2",
                        "-translate-x-1/2",
                        "-translate-y-1/2",
                        "w-5",
                        "h-5",
                        "pointer-events-none"
                    );
                    a.appendChild(play);
                }

                const span = document.createElement("span");
                span.textContent = diamond.ad || "No Announcement";
                span.classList.toggle("opacity-50", !diamond.ad);
                const div = document.createElement("div");
                div.classList.add("flex", "items-center");
                div.append(a, span);

                const button = document.createElement("button");
                button.dataset.url = diamond.url;
                button.textContent =
                    this.getSelectedDiamond() === diamond.id
                        ? "✅"
                        : diamond.url
                          ? "🟦"
                          : "⬜️"; //☑️

                li.onclick = () => {
                    this.reset();
                    button.textContent = "✅";
                    history.replaceState(null, "", `#/trove/${diamond.id}`);
                    this.container.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                    this.renderActions();

                    // window.location.hash = `#/trove/${diamond.id}`;
                    // button.disabled = true;
                    // await this.renderActions();
                    // button.disabled = false;
                };

                li.append(div, button);
                this.diamonds.appendChild(li);
            }
        } else {
            const li = document.createElement("li");
            li.classList.add(
                "text-gray-400",
                "dark:text-gray-500",
                "text-center",
                "items-center",
                "w-full",
                "leading-normal",
                "p-3"
            );
            li.innerHTML =
                "Share your <strong>photos</strong>, <strong>videos</strong>, and <strong>voice messages</strong> as <strong>B-Diamonds</strong> to help your recipients save <u>storage space</u> on their phone!";
            this.diamonds.appendChild(li);
        }

        this.main.hideSpinner();
    }

    private reset() {
        this.diamonds
            .querySelectorAll("button")
            .forEach(
                (button: HTMLButtonElement) =>
                    (button.textContent = button.dataset.url ? "🟦" : "⬜️")
            );
    }

    private async renderActions() {
        const diamond = this.getSelectedDiamond()
            ? await this.trove.get(this.getSelectedDiamond())
            : null;
        const isCreator = !!diamond && diamond.uid === this.heartbank.user?.uid;

        const parent = this.ad.parentElement as HTMLElement;
        parent.classList.toggle("hidden", !diamond);

        this.ad.classList.toggle("hidden", isCreator);
        this.creator.classList.toggle("hidden", isCreator);
        this.actions.classList.toggle("hidden", !isCreator);
        this.cover.classList.toggle("hidden", !diamond);
        this.footer.classList.toggle("hidden", !diamond);
        this.info.classList.toggle("hidden", !diamond);
        this.thank.classList.toggle(
            "hidden",
            !(diamond && diamond.uid !== this.heartbank.user?.uid)
        );

        if (diamond) {
            this.creator.innerHTML = `<hb-me class="ml-0" uid="${diamond.uid}"></hb-me>`;
            this.ad.textContent = diamond.ad;
            this.cover.poster =
                diamond.type === "audio"
                    ? AUDIO
                    : diamond.type === "video"
                      ? diamond.thumbnail
                      : diamond.src;
            this.cover.src = diamond.src;
            this.cover.controls = diamond.type !== "image";
            this.cover.muted = diamond.type === "video";
            this.cover.autoplay = diamond.type === "video";

            const creator = await this.me.getName3(diamond.uid);
            this.info.innerHTML = isCreator
                ? `You will save your recipient <strong class="font-black">${this.formatBytesRounded(diamond.size)}</strong> of space by sharing as a B-Diamond`
                : `<strong class="font-bold">${creator}</strong> saved you <strong class="font-black">${this.formatBytesRounded(diamond.size)}</strong> of space by sharing as a B-Diamond`;
            this.thank.innerHTML = `Thank <strong>${creator}</strong>`;
            this.renderTokens(diamond.uid, creator, diamond.size);
        } else {
            this.creator.innerHTML = "";
            this.ad.textContent =
                "This B-Diamond has been deleted by the Creator";
        }
    }

    private renderTokens(uid: string, name: string, size: number) {
        this.tokens.innerHTML = "";

        // cancel
        const button = document.createElement("button");
        button.type = "button";
        button.className = `text-white bg-red-900 focus:ring-4 focus:outline-none font-medium rounded-lg text-base w-full px-5 py-2.5 text-center`;
        button.innerHTML = `Cancel`;
        button.onclick = () => {
            this.footer.classList.remove("hidden");
            this.thank.classList.remove("hidden");
            this.tokens.classList.add("hidden");
        };
        this.tokens.appendChild(button);

        for (const token of TOKENS) {
            const button = document.createElement("button");
            button.type = "button";
            //button.dataset.token = token.token;
            button.className = `text-white ${token.color} focus:ring-4 focus:outline-none font-medium rounded-lg text-base w-full px-5 py-2.5 text-center`;
            button.innerHTML = `Give ${token.emoji} B-Token to <strong>${name}</strong>`;
            button.onclick = () => {
                localStorage.setItem(
                    "token-gold",
                    `Thanks so much for saving me ${this.formatBytesRounded(size)} of space`
                );
                window.location.hash = `#/token/${token.token}/${uid}/0/0`;
            };
            this.tokens.appendChild(button);
        }
    }

    private getSelectedDiamond() {
        return window.location.hash.split("/")[2];
    }

    async show(id: string) {
        this.footer.classList.add("hidden");
        this.thank.classList.add("hidden");
        this.tokens.classList.add("hidden");
        await this.renderActions();

        if (id)
            this.trove.addMiner(this.heartbank.user?.uid || "", id); // stats // await
        else this.reset();
        this.modal.show();
    }

    hide() {
        this.modal.hide();
    }

    // same as b app
    private formatBytesRounded(bytes: number): string {
        if (bytes >= 1024 ** 3) {
            // 1 GB or more
            const GB = Math.round(bytes / 1024 ** 3);
            return `${GB} GB`;
        } else if (bytes >= 1024 ** 2) {
            // 1 MB or more
            const MB = Math.round(bytes / 1024 ** 2);
            return `${MB} MB`;
        } else if (bytes >= 1024) {
            // 1 KB or more
            const KB = Math.round(bytes / 1024);
            return `${KB} KB`;
        } else {
            // less than 1 KB
            return `${bytes} B`;
        }
    }
}
